import Header from "../menu/Header";
import PageIntro from "../homepage/desktop_components/intro_section/IntroSection";
import { TopSectionsPictures } from "../../enums/images";
import { PublicEventsTexts } from "../../enums/page_texts/public_events_texts";
import PublicEventsSection from "./PublicEventsSection";
import Footer from "../footer/Footer";
import StaticFooter from "../footer/StaticFooter";
import { useQuery } from "@tanstack/react-query";
import { loadPublicEventsPageData } from "../../services/api";
import LoadingSpinner from "../general/LoadingSpinner";
import SeoHelmet from "../general/SeoHelmet";
import ApiErrorScreen from "../general/ApiErrorScreen";
import BreadcrumbSchema from "../general/BreadcrumbSchema";

function PublicEventsPage() {
  const { isLoading, isError, refetch } = useQuery({
    queryKey: ["public-events-page"],
    queryFn: async () => {
      await loadPublicEventsPageData();
      return true;
    },
  });

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <ApiErrorScreen onRetry={() => refetch()} />;
  }

  return (
    <div>
      <SeoHelmet
        title="DJ Mayday | Animations DJ publiques en Wallonie — Bars, Clubs, Festivals"
        description="DJ Mayday anime bars, clubs, festivals et événements publics à Liège et en Wallonie. Techno, house, électro — une expérience DJ professionnelle pour vos soirées."
        url="https://www.djmayday.com/public-events"
      />
      <BreadcrumbSchema
        items={[
          { name: "Accueil", url: "https://www.djmayday.com/" },
          { name: "Événements publics", url: "https://www.djmayday.com/public-events" },
        ]}
      />
      <h1 style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>
        Animations DJ publiques en Wallonie — Bars, Clubs, Festivals à Liège | DJ Mayday
      </h1>
      <Header />
      <PageIntro
        title={PublicEventsTexts.Title}
        description={PublicEventsTexts.DescriptionText}
        backgroundImage={TopSectionsPictures.PublicEventsPage}
        modalText={PublicEventsTexts.ModalText}
        aboutModal={PublicEventsTexts.AboutModal}
        closeModal={PublicEventsTexts.CloseModal}
        buttonText={PublicEventsTexts.ButtonText}
      />
      <PublicEventsSection />
      <StaticFooter />
      <Footer />
    </div>
  );
}

export default PublicEventsPage;
